import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setFinalDetails } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchFinalDetails = createAsyncThunk(
  "finalDetailsScreen/fetchFinalDetails",
  async (country) => {
    const apiURL = country?.companyType
      ? `${baseUrl}/api/registration-form-page/4/${country.countryCode}/?company_type=${country.companyType}`
      : `${baseUrl}/api/registration-form-page/4/${country.countryCode}/`;
    return fetch(apiURL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language":
          country.language === "en" ? "en-UK" : country.language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getFinalDetails =
  (countryCode, language, companyType) => async (dispatch) => {
    const result = await dispatch(
      fetchFinalDetails({ countryCode, language, companyType })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setFinalDetails(data?.page_content));

    return data;
  };

export const finalDetailsSlice = createSlice({
  name: "finalDetailsScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinalDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFinalDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchFinalDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default finalDetailsSlice.reducer;
